import { render, staticRenderFns } from "./CarouselFlickity.vue?vue&type=template&id=6b69942e"
import script from "./CarouselFlickity.vue?vue&type=script&lang=js"
export * from "./CarouselFlickity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports